export default __webpack_public_path__ + "static/media/WhiteSuscripcion.d1b119eb.svg";